module.exports = __webpack_public_path__ + "fe2f0d4c8d8c06b0bab74e0f2cac4d00.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/plant-hat.jpg
 ** module id = 454
 ** module chunks = 0
 **/